// CRIS CREDIT - estado compartilhado da IA explicativa (leve, em memoria).
// Reutiliza o resultado do proprio teste OpenAI para atualizar o indicador
// visual imediatamente, sem refresh de pagina e sem polling continuo.
// NUNCA expoe a chave. NAO altera score/limite/gate/politica/modo DRY_RUN.

const LABELS = {
  ACTIVE: "OpenAI ativa",
  FALLBACK: "Fallback determinístico",
  UNAVAILABLE: "OpenAI indisponível",
};
const MESSAGES = {
  ACTIVE: "Explicações assistidas por OpenAI.",
  FALLBACK: "Explicações geradas pelo modo determinístico.",
  UNAVAILABLE: "Explicações geradas pelo modo determinístico.",
};

const toStatus = (state, extra = {}) => ({ state, label: LABELS[state], message: MESSAGES[state], ...extra });

// Mapeia o retorno de POST /credit/ai/test -> estado do indicador.
export function mapTestResult(t) {
  if (!t) return null;
  if (t.ok) return toStatus("ACTIVE", { latency_ms: t.latency_ms });
  if (t.configured === false) return toStatus("UNAVAILABLE");
  return toStatus("FALLBACK");
}

let last = null;
const listeners = new Set();

export function getLastStatus() {
  return last;
}

export function subscribeAiStatus(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

// Publica o estado derivado do teste para todos os indicadores montados.
export function publishAiTest(testResult) {
  const status = mapTestResult(testResult);
  if (!status) return;
  last = status;
  listeners.forEach((cb) => cb(status));
}
